import { Loading, TrySearchUser } from "components/commons";
import {
  BellIcon,
  BellSnoozeIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import { useController } from "./Controller";
import slugs from "navigation/slugs";
import { useLocation, useNavigate } from "react-router-dom";
import { formatNumber } from "utils/number/number";
import { exploreTabs } from "helpers/constants";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import { ReactComponent as Checklist } from "assets/icons/checklist.svg";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

const renderBottomCard = (item: any) => {
  return (
    <>
      <div className="flex justify-between text-xs font-medium px-4 py-2 border-t border-gray-800">
        <div className="flex items-center">
          <div className="flex items-baseline gap-2">
            <span className="uppercase text-slate-500">Holder:</span>
            <span className="text-info font-mono whitespace-nowrap">
              {item?.total_holders || "-"}
            </span>
          </div>
        </div>
        <div className="flex items-baseline gap-2">
          <span className="uppercase text-slate-500">Price:</span>
          <span className="text-secondary font-mono whitespace-nowrap">
            {Number(item?.current_price)
              ? Number(item?.current_price) < 0.0001
                ? "<0.0001"
                : "~" + item?.current_price.toFixed(4) + " Ξ"
              : "-"}
          </span>
        </div>
      </div>
      <div className="flex justify-between text-xs font-medium px-4 pb-2">
        <div className="flex items-center">
          <div className="flex items-baseline gap-2">
            <span className="uppercase text-slate-500">Shares:</span>
            <span className="text-info font-mono whitespace-nowrap">
              {item?.total_shares || "-"}
            </span>
          </div>
        </div>
        <div className="flex items-baseline gap-2">
          <span className="uppercase text-slate-500">Total Volume: </span>
          <span className="text-secondary font-mono whitespace-nowrap">
            {Number(item?.total_volume)
              ? item.total_volume.toFixed(4) + " Ξ"
              : " - "}
          </span>
        </div>
      </div>
    </>
  );
};

function Explore() {
  const {
    val,
    setVal,
    handleSearch,
    datas,
    isLoading,
    handleKeyDown,
    handleSubscribe,
    handleUnsubscribe,
    currentTab,
    setCurrentTab,
    trendingIdols,
    isLoadingTrending,
  } = useController();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <>
      <div className="flex-1 flex flex-col mt-4">
        {/* Search input */}
        <div className="flex gap-2 relative items-center mb-4 shadow-sm">
          <input
            placeholder="Search by name"
            className="w-full pl-4 py-[14px] pr-14 border-2 border-slate-700 bg-transparent rounded-xl focus:outline-none text-slate-300 text-sm"
            value={val}
            onChange={(e) => {
              e.preventDefault();
              navigate(`${pathname}?search=${e.currentTarget.value}`, {
                replace: true,
              });
              setVal(e.currentTarget.value);
            }}
            onKeyDown={handleKeyDown}
          />

          <div
            className="absolute inset-y-0 right-0 py-[14px] px-3 cursor-pointer border-l-2 border-slate-700 "
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <button
              className="shadow-sm rounded-xl text-sm"
              onClick={handleSearch}
            >
              <MagnifyingGlassIcon className="w-5 inline" />
            </button>
          </div>
        </div>
        {/* End: Search input */}
        <div className="w-full flex justify-start items-center border-b border-gray-800 text-left bg-base-300 z-10 mb-4">
          {exploreTabs.map((tab) => (
            <div
              key={tab.name}
              className={classNames(
                tab.name === currentTab
                  ? "border-secondary text-white"
                  : "border-transparent text-slate-300 hover:border-secondary hover:text-white",
                "whitespace-nowrap border-b-4 rounded text-sm font-normal py-3 w-24 px-2 cursor-pointer"
              )}
              onClick={() => {
                setCurrentTab(tab.name as any);
              }}
            >
              {tab.name}
            </div>
          ))}
        </div>

        {(isLoading || isLoadingTrending) && <Loading />}

        {!isLoadingTrending &&
          datas?.length === 0 &&
          currentTab === "On fan.tech" && (
            <>
              <div className="my-3">
                <span className="text-xl">🔥</span> Trending Idols
              </div>
              <div className="flex flex-col gap-4 w-full">
                {trendingIdols?.map((item: any, idx: number) => {
                  return (
                    <div
                      className="border-2 rounded-xl border-gray-800"
                      key={idx}
                    >
                      <div
                        className={`flex p-4 gap-4 justify-between items-center `}
                      >
                        <div className="flex items-center  gap-3 w-full">
                          <div
                            className="shadow-sm overflow-hidden flex justify-center items-center relative"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(`${slugs.profile}/${item?.id}`);
                            }}
                          >
                            {item?.metadata?.avatar_168x168 ? (
                              <img
                                className="h-12 w-12 shadow-sm rounded-full object-fill"
                                src={item?.metadata?.avatar_168x168}
                                alt="avatar"
                              />
                            ) : (
                              <i className="fa-duotone fa-user text-2xl text-primary"></i>
                            )}
                            {item?.user_id ? (
                              <Checklist className="w-4 h-4 absolute bottom-0 right-0" />
                            ) : null}
                          </div>

                          <div className="flex-1 flex justify-between">
                            <h6
                              className="flex flex-col items-baseline transition-all"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`${slugs.profile}/${item?.id}`);
                              }}
                            >
                              <span
                                className={`text-base font-normal leading-none mr-1 mb-1`}
                              >
                                {item?.nickname}
                              </span>
                              <span className="text-xs font-normal text-slate-500">
                                {item?.follower_count
                                  ? formatNumber(Number(item.follower_count))
                                  : "-"}{" "}
                                Followers
                              </span>
                            </h6>
                            {item?.isSubscribe ? (
                              <BellIcon
                                className="w-6 h-6  text-[#1BC57E]"
                                onClick={() => handleUnsubscribe(item.id, idx)}
                              />
                            ) : (
                              <BellSnoozeIcon
                                className="w-6 h-6"
                                onClick={() => handleSubscribe(item.id, idx)}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      {renderBottomCard(item)}
                    </div>
                  );
                })}
              </div>
            </>
          )}

        {!isLoading && datas?.length === 0 && currentTab === "On TikTok" && (
          <TrySearchUser />
        )}

        <div
          className={`flex-1 flex flex-col gap-4 w-full ${
            datas.length === 0 ? "justify-center" : ""
          }`}
        >
          {!isLoading &&
            datas.length > 0 &&
            datas.map((item, idx) => {
              return (
                <div className="border-2 rounded-xl border-gray-800" key={idx}>
                  <div
                    className={`flex p-4 gap-4 justify-between items-center border-b border-gray-800`}
                  >
                    <div className="flex items-center  gap-3 w-full">
                      <div
                        className="h-12 w-12 shadow-sm rounded-full overflow-hidden flex justify-center items-center"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`${slugs.profile}/${item?.id}`);
                        }}
                      >
                        {item?.metadata?.avatar_168x168 ? (
                          <img
                            className="h-12 w-12 shadow-sm rounded-full object-fill"
                            src={item?.metadata?.avatar_168x168}
                            alt=""
                          />
                        ) : (
                          <i className="fa-duotone fa-user text-2xl text-primary"></i>
                        )}
                      </div>

                      <div className="flex-1 flex justify-between">
                        <h6
                          className="flex flex-col items-baseline transition-all"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`${slugs.profile}/${item?.id}`);
                          }}
                        >
                          <span
                            className={`text-base font-normal leading-none mr-1 mb-1`}
                          >
                            {item?.nickname}
                          </span>
                          <span className="text-xs font-normal text-slate-500">
                            {item?.follower_count
                              ? formatNumber(Number(item.follower_count))
                              : "-"}{" "}
                            Followers
                          </span>
                        </h6>
                        {item?.isSubscribe ? (
                          <BellIcon
                            className="w-6 h-6  text-[#1BC57E]"
                            onClick={() => handleUnsubscribe(item.id, idx)}
                          />
                        ) : (
                          <BellSnoozeIcon
                            className="w-6 h-6"
                            onClick={() => handleSubscribe(item.id, idx)}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between text-xs font-medium p-4">
                    <div className="flex items-center">
                      <div className="flex items-baseline gap-2">
                        <span className="uppercase text-slate-500">
                          Holder:
                        </span>
                        <span className="text-info font-mono whitespace-nowrap">
                          {item?.total_holders || "-"}
                        </span>
                      </div>
                    </div>

                    <div className="flex items-center gap-4">
                      <div className="flex items-baseline gap-2">
                        <span className="uppercase text-slate-500">
                          Shares:
                        </span>
                        <span className="text-primary font-mono whitespace-nowrap">
                          {item?.total_shares || "-"}
                        </span>
                      </div>

                      <div className="flex items-baseline gap-2">
                        <span className="uppercase text-slate-500">Price:</span>
                        <span className="text-secondary font-mono whitespace-nowrap">
                          {Number(item?.current_price)
                            ? "~" + item?.current_price + " Ξ"
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
}

export { Explore as default };

/**
 * (
            datas.map((item, idx) => {
              return (
                <div className="border-2 rounded-xl border-gray-800" key={idx}>
                  <div
                    className={`flex p-4 gap-4 justify-between items-center border-b border-gray-800`}
                  >
                    <div className="flex items-center  gap-3 w-full">
                      <div
                        className="h-12 w-12 shadow-sm rounded-full overflow-hidden flex justify-center items-center"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`${slugs.profile}/${item?.id}`);
                        }}
                      >
                        {item?.metadata?.avatar_168x168 ? (
                          <img
                            className="h-12 w-12 shadow-sm rounded-full object-fill"
                            src={item?.metadata?.avatar_168x168}
                          />
                        ) : (
                          <i className="fa-duotone fa-user text-2xl text-primary"></i>
                        )}
                      </div>

                      <div className="flex-1 flex justify-between">
                        <h6
                          className="flex flex-col items-baseline transition-all"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`${slugs.profile}/${item?.id}`);
                          }}
                        >
                          <span
                            className={`text-base font-normal leading-none mr-1 mb-1`}
                          >
                            {item?.nickname}
                          </span>
                          <span className="text-xs font-normal text-slate-500">
                            {item?.follower_count
                              ? formatNumber(Number(item.follower_count))
                              : "-"}{" "}
                            Followers
                          </span>
                        </h6>
                        {item?.isSubscribe ? (
                          <BellIcon
                            className="w-6 h-6  text-[#1BC57E]"
                            onClick={() => handleUnsubscribe(item.id, idx)}
                          />
                        ) : (
                          <BellSnoozeIcon
                            className="w-6 h-6"
                            onClick={() => handleSubscribe(item.id, idx)}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between text-xs font-medium p-4">
                    <div className="flex items-center">
                      <div className="flex items-baseline gap-2">
                        <span className="uppercase text-slate-500">
                          Holder:
                        </span>
                        <span className="text-info font-mono whitespace-nowrap">
                          {item?.total_holders || "-"}
                        </span>
                      </div>
                    </div>

                    <div className="flex items-center gap-4">
                      <div className="flex items-baseline gap-2">
                        <span className="uppercase text-slate-500">
                          Shares:
                        </span>
                        <span className="text-primary font-mono whitespace-nowrap">
                          {item?.total_shares || "-"}
                        </span>
                      </div>

                      <div className="flex items-baseline gap-2">
                        <span className="uppercase text-slate-500">Price:</span>
                        <span className="text-secondary font-mono whitespace-nowrap">
                          {Number(item?.current_price)
                            ? "~" + item?.current_price + " Ξ"
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )
 */
